import { sharedService } from "@/modules/shared/store/services/shared-service";
import { setStates, setFetching, setError } from "@/modules/shared/store/reducers/states-slice";

/**
 * getStates — RTK Query endpoint for /parameters/countries/:countryId/states.
 *
 * Bridge: dispatches to the states-slice so existing consumers
 * reading `state.states.*` keep working without changes.
 */
const getStates = sharedService.injectEndpoints({
  endpoints: builder => ({
    getStates: builder.query({
      query: countryId => `parameters/countries/${countryId}/states`,
      transformResponse: response => response.items,
      providesTags: (result, error, countryId) => [{ type: "States", id: countryId }],
      async onQueryStarted(countryId, { dispatch, queryFulfilled }) {
        dispatch(setFetching());
        try {
          const { data } = await queryFulfilled;
          dispatch(setStates(data));
        } catch (err) {
          dispatch(setError(err?.error?.data?.userDescription ?? "Failed to load states"));
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetStatesQuery } = getStates;

